<template>
    <section class="leafly-section ">
        <div class=" mx-auto w-max-full ">
            <div class="mb-6 text-center " data-aos="fade-up" data-aos-delay="100">
                <h2 class="leafly-section-title">Why Choose Us</h2>
                <p class="leafly-section-second-title mb-[16px]">At LeaflyPackaging, we don’t just supply packaging — we build ideas that sell.</p>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-0 text-white">
                <!-- 左上：About Our Company -->
                <div class=" overflow-hidden item ">
                    <div
                        class="p-8 h-full flex flex-col  hover-zoom-bg  "
                        style="
                        background-image: url('https://images.leaflypackaging.com/profile/upload/2025/11/24/0_20251124092411A058.webp');
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat; ">
                        <div class="max-w-xl relative pt-16  ml-[5%]" data-aos="fade-up" data-aos-delay="100">
                            <div class="absolute top-0 left-0 right-0 item-header">
                                <h3>About Leafly Packaging</h3>
                            </div>
                            <p class="item-content">
                                <span>Founded in 2014 and based in Shenzhen, China — a city known for its high quality and efficient service — Leafly Packaging has been providing smart, reliable packaging solutions for over 10 years.</span>
                                <span class="mt-4 block">We specialize in cannabis, food, and cosmetic packaging, offering a full range of products including paper boxes, plastic bags, glass containers, and plastic containers.</span>
                                <span class="mt-4 block">With more than 500 brands trusting us for OEM packaging, we bring your creative ideas to life quickly and precisely — helping your brand stand out with packaging that inspires confidence and quality.</span>
                            </p>

                            <nuxt-link href="/why-leafly.html" class="item-button leafly-btn leafly-btn-outline border-white text-white hover:bg-white hover:text-primary self-start">View Product</nuxt-link>
                        </div>
                    </div>
                </div>

                <!-- 左上：About Our Company -->
                <div class=" overflow-hidden item ">
                    <div
                        class="p-8 h-full flex flex-col  hover-zoom-bg  "
                        style="
                            background-image: url('https://images.leaflypackaging.com/profile/upload/2025/11/23/1_20251123163845A055.webp');
                            background-position: center;
                            background-size: cover;
                            background-repeat: no-repeat; ">
                        <div class="max-w-xl relative pt-16  ml-[5%]" data-aos="fade-up" data-aos-delay="100">
                            <div class="absolute top-0 left-0 right-0 item-header">
                                <h3>What We Do</h3>
                            </div>
                            <p class="item-content">
                                <span>At Leafly Packaging, we turn your packaging ideas into reality — quickly, creatively, and cost-effectively.</span>
                                <span class="mt-4 block">We provide one-stop packaging solutions for a wide range of industries, including cannabis, food, and cosmetics. From design and dieline creation to sampling, mass production, and delivery, we handle every step with precision and care.</span>
                                <span class="mt-4 block">Our team handles creative design, product sourcing, tooling, and production, ensuring every detail meets your vision and brand identity.</span>
                                <span class="mt-4 block">Whether you need a custom jar, tin, or box, we deliver packaging that’s practical, beautiful, and built to impress.</span>
                            </p>
                            <nuxt-link href="/industry.html" class="item-button leafly-btn leafly-btn-outline border-white text-white hover:bg-white hover:text-primary self-start">View Product</nuxt-link>
                        </div>
                    </div>
                </div>

                <!-- 左下：About Our Service -->
                <div class=" overflow-hidden item ">
                    <div
                        class="p-8 h-full flex flex-col  hover-zoom-bg  "
                        style="
                        background-image: url('https://images.leaflypackaging.com/profile/upload/2025/11/23/2_20251123164020A056.webp');
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat; ">
                        <div class="max-w-xl relative pt-16  ml-[5%]" data-aos="fade-up" data-aos-delay="100">
                            <div class="absolute top-0 left-0 right-0 item-header">
                                <h3>Our Service</h3>
                            </div>

                            <p class="item-content">
                                <span>At Leafly Packaging, we believe great service means more than just delivering products — it’s about delivering solutions that work for you.</span>
                                <span class="mt-4 block">We respect your ideas and help bring them to life with speed and precision:</span>
                                <span class="block pl-4">  • Custom dielines within 1 day</span>
                                <span class="block pl-4">  • Physical samples ready in 3 days</span>
                                <span class="block pl-4">  • Mass production shipped within a week</span>
                                <span class="mt-4 block">From design development to production and logistics, our team provides responsive communication, professional guidance, and reliable after-sales support every step of the way.</span>
                                <span class="mt-4b lock">With over 10 years of packaging experience, we make sure every project runs smoothly — so you can focus on growing your brand while we take care of the packaging.</span>
                            </p>
                            <nuxt-link href="/services.html" class="item-button leafly-btn leafly-btn-outline border-white text-white hover:bg-white hover:text-primary self-start">View Product</nuxt-link>
                        </div>
                    </div>
                </div>

                <!-- 右下：What Makes Us Different -->

                <div class=" overflow-hidden item ">
                    <div
                        class="p-8 h-full flex flex-col  hover-zoom-bg  "
                        style="
                        background-image: url('https://images.leaflypackaging.com/profile/upload/2025/11/23/3_20251123164021A057.webp');
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;">
                        <div class="max-w-xl relative pt-16 ml-[5%]" data-aos="fade-up" data-aos-delay="100">
                            <div class="absolute top-0 left-0 right-0 item-header">
                                <h3>What Makes Us Different</h3>
                            </div>
                            <p class="item-content">

                                <span class="mt-4 block">Our team is dedicated to:</span>
                                <span class="mt-4 block">From design, sourcing, and production — we move fast, think creatively, and deliver packaging that truly stands out.</span>
                                <span class="mt-4 block">We don’t just make packaging — we create solutions that reflect your brand, your product, and your vision.</span>
                            </p>
                            <nuxt-link href="/contact-us" class="item-button leafly-btn leafly-btn-outline border-white text-white hover:bg-white hover:text-primary self-start">View Product</nuxt-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .leafly-section{
        padding-bottom: 0px;
    }

    .container {
        max-width: 100% !important;
    }

    .item{
        min-height:500px
    }
    .item-header{
        font-size:3rem;
        font-weight: 400;
        line-height: 1;

    }
    .item-content{
        font-size:1.25rem;
        font-weight:300;
        margin-top:1rem;
    }
    .item-button{
        margin-top:1.75rem;
        padding: 0.75rem 4rem;
    }

    /* 背景图片 hover 放大效果 - 使用 background-size 过渡 */
    .hover-zoom-bg {
        position: relative;
        overflow: hidden;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        transition: box-shadow 0.4s ease, background-size 2.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        will-change: background-size;
        /* 初始状态：使用 100% 100% 确保背景图撑满且可以平滑过渡 */
        background-size: 100% 100% !important;
        /* 确保背景图居中 */
        background-position: center !important;
    }

    /* 添加遮盖层 */
    .hover-zoom-bg::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5); /* 黑色半透明遮盖层，可调整透明度 */
        z-index: 1;
        transition: background-color 0.3s ease;
    }

    .hover-zoom-bg:hover {
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
        /* 悬停时放大背景图，同时放大宽度和高度确保始终覆盖 */
        background-size: 120% 120% !important;
    }

    /* 鼠标悬停时稍微减淡遮盖层 */
    .hover-zoom-bg:hover::before {
        background: rgba(0, 0, 0, 0.3);
    }

    /* 为内容层添加相对定位，确保它在遮盖层之上 */
    .hover-zoom-bg > * {
        position: relative;
        z-index: 2;
    }
</style>
